import {post} from "../api";
import {PaginatedFilingLocations, PagingToken, FilterOption} from "../models";

export class DocumentSearch {
    private timer: NodeJS.Timeout = null;

    public runThrottledSearch = (
        userId: string,
        tenantId: string,
        teamsId: string,
        channelId: string,
        storageType: string,
        searchPhrase: string,
        folderSearch: boolean,
        shouldIncludeCheckedOutFiles: boolean,
        searchAllDms: boolean,
        isFirstSearch: boolean,
        searchFilter: string,
        selectedFilters: FilterOption[],
        onSearchComplete: (results: PaginatedFilingLocations) => void,
        onError: (message: string) => void,
        pagingToken: PagingToken = null
    ) => {
        clearTimeout(this.timer);

        if (!searchPhrase) {
            return;
        }

        this.timer = setTimeout(() => {
            this.runSearchNow(
                userId,
                tenantId,
                teamsId,
                channelId,
                storageType,
                searchPhrase,
                shouldIncludeCheckedOutFiles,
                searchAllDms,
                isFirstSearch,
                folderSearch,
                selectedFilters,
                onSearchComplete,
                onError,
                searchFilter,
                pagingToken
            );
        }, 600); // changed from 400 to 600 as search would trigger when holding delete key to delete search phrase
    };

    public runSearchNow = (
        userId: string,
        tenantId: string,
        teamsId: string,
        channelId: string,
        storageType: string,
        searchPhrase: string,
        shouldIncludeCheckedOutFiles: boolean,
        searchAllDms: boolean,
        isFirstSearch: boolean,
        folderSearch: boolean,
        selectedFilters: FilterOption[],
        onSearchComplete: (results: PaginatedFilingLocations) => void,
        onError: (message: string) => void,
        searchFilter: string,
        pagingToken: PagingToken = null
    ) => {
        post("/api/teamsdmsintegration/SearchDmsLocations", {
            SearchString: searchPhrase,
            FirstSearch: isFirstSearch,
            folderSearch,
            StorageType: storageType,
            TeamsId: teamsId,
            ChannelId: channelId,
            TenantId: tenantId,
            UserId: userId,
            SearchFilter: searchFilter,
            NextPage: pagingToken,
            ShouldIncludeCheckedOutFiles: shouldIncludeCheckedOutFiles,
            SearchAllOfDMS: searchAllDms,
            FilterParameters: selectedFilters
        })
            .then((r) => {
                if (r.status.toString().startsWith("2")) {
                    return r.json();
                }
                if (r.status.toString() == "403") {
                    throw new Error("Search Failed. You do not have permission to search within this folder.");
                }
                throw new Error("Search Failed.");
            })
            .then((r) => {
                onSearchComplete(r);
            })
            .catch((error) => onError(error.toString()));
    };
}
